module.exports = __webpack_public_path__ + "img/B3.b2bc4cbc.png";